import React from 'react';
import { Destination } from '../../../data/destinationData';

interface ThingsToDoProps {
  destination: Destination;
}

const DestinationThingsToDo: React.FC<ThingsToDoProps> = ({ destination }) => {
  return(
    <>
      <div className='flex flex-wrap'>
        <div className='w-full md:w-3/4 md:pr-4'>
          <p dangerouslySetInnerHTML={{ __html: destination.thingsToDoTab}}>
          </p>
        </div>
      </div>
    </>
  );
};

export default DestinationThingsToDo;
